module.exports = __webpack_public_path__ + "img/LastWarning.e89f45e1.jpg";